/* eslint-disable react/prop-types */
import { useTranslation } from 'react-i18next'
import { UpsellBaseModal } from '../UpsellBaseModal'
import { OfferBox } from '../OfferBox'

export const SinglePurchaseModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  offer,
  primaryAction,
  dismissAction,
  showCloseButton = true,
}) => {
  const { t } = useTranslation()

  return (
    <UpsellBaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? t('upsell.modals.single_purchase_title')}
      subtitle={subtitle ?? t('upsell.modals.single_purchase_subtitle')}
      titleId="single-purchase-modal-title"
      showCloseButton={showCloseButton}
      primaryAction={primaryAction}
      secondaryAction={dismissAction}
    >
      {offer && (
        <OfferBox
          variant="solid"
          label={offer.label}
          price={offer.price}
          description={offer.description}
          subdescription={offer.subdescription}
        />
      )}
    </UpsellBaseModal>
  )
}

export default SinglePurchaseModal
